import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from "reactstrap";
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import CreateFeedModal from './FeedLibrary/CreateFeedModal';
import AddFieldModal from './FeedLibrary/AddFieldModal';
import { ToastContainer } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setBreadcrumb } from '../../slices/auth/menu/reducer';

function Feeds() {
  document.title = "Feeds | Adcropper";

  return (
    <React.Fragment>
      {/* <BreadCrumb title="Feeds" pageTitle="Pages" /> */}
      <Outlet />
      <CreateFeedModal />
      <AddFieldModal />
    </React.Fragment>
  )
}

export default Feeds
